import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="volumenes" className="defer-paint w-full scroll-mt-6 bg-canvas py-12 sm:py-14" aria-labelledby="volumes-heading" data-id="element-219" data-mp="cm526r4zghlj">
      <div className="mx-auto max-w-3xl px-6" data-id="element-220" data-mp="3g4q054a97n0t">
        <SectionHeading eyebrow="La soluzione arriva oggi" title={<span id="volumes-heading" data-id="element-222" data-mp="3c4fgwpxgb040">
              I 6 volumi della tua biblioteca
            </span>} lead="Scegli il volume, apri la lezione ed entra in sala: meno di 10 minuti di preparazione. Apri ogni volume per vedere cosa contiene." data-id="element-221" data-mp="3g5hk1huhnwb9" />

        <ol className="mt-10 space-y-3" data-id="element-223" data-mp="3l2zvpfzw4pmy">
          {volumes.map((volume, index) => {
          const isOpen = openIndex === index;
          return <li key={volume.code} className={`rounded-3xl border bg-card transition-colors duration-150 ease-out ${isOpen ? 'border-accent/40' : 'border-line'}`} data-id="element-224" data-mp="2sfwwsmraycw6" data-mpi={index}>
                <h3 data-id="element-225" data-mp="29deboe2wbb62">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-center gap-4 rounded-3xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent sm:px-6" data-id="element-226" data-mp="2eelh46hkfy9k">
                    <span className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border font-serif text-lg font-bold transition-colors duration-150 ease-out ${isOpen ? 'border-accent bg-accent text-white' : 'border-accent/25 bg-accent-soft text-accent'}`} aria-hidden="true" data-id="element-227" data-mp="1qhxy4a0d0dvr">
                      {volume.code}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-228" data-mp="3bu92fg6qdltu">
                      <span className="sr-only" data-id="element-229" data-mp="3btpo09gahfkk">Volume {index + 1}: </span>
                      <span className="block font-serif text-xl font-bold leading-tight text-ink sm:text-2xl" data-id="element-230" data-mp="3fu9jl8l7sb4l">
                        {volume.name}
                      </span>
                      <span className="mt-1.5 flex flex-wrap items-center gap-2" data-id="element-231" data-mp="1bsj1skvdqzdb">
                        <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-accent" data-id="element-232" data-mp="1pr8xbw2jwqzk">
                          {volume.lessons}
                        </span>
                        {volume.featured ? <span className="rounded-full bg-accent-soft px-2.5 py-0.5 font-sans text-[10px] font-semibold uppercase tracking-[0.12em] text-accent" data-id="element-233" data-mp="x2btgxz36wqc">
                            Il più completo
                          </span> : null}
                      </span>
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-muted transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-234" data-mp="121eqbv4wxwn8" />
                  </button>
                </h3>

                <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-235" data-mp="9c7n4iuikivn">
                  <div className="overflow-hidden" data-id="element-236" data-mp="2ps4c2my3eu1n">
                    <div className="border-t border-line px-5 py-5 sm:px-6" data-id="element-237" data-mp="2bzwggyijp94j">
                      <p className="font-sans text-[0.92rem] leading-relaxed text-muted" data-id="element-238" data-mp="2bxtm62ad0tu0">
                        {volume.description}
                      </p>

                      <div className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-239" data-mp="34pwqtcvtfees">
                        <div className="rounded-2xl bg-surface p-4" data-id="element-240" data-mp="38qozo50rzhaj">
                          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-241" data-mp="38nufmelobyhn">
                            Risolve
                          </p>
                          <p className="mt-2 font-sans text-[0.86rem] leading-relaxed text-ink" data-id="element-242" data-mp="2znny8hmuued7">
                            {volume.solves}
                          </p>
                        </div>
                        <div className="rounded-2xl border border-accent/25 bg-accent-soft p-4" data-id="element-243" data-mp="1o88yx776baex">
                          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-accent" data-id="element-244" data-mp="23la28fgt8qep">
                            Risultato
                          </p>
                          <p className="mt-2 font-sans text-[0.86rem] leading-relaxed text-ink" data-id="element-245" data-mp="1us6mu1mlu3hf">
                            {volume.result}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>

        <p className="mt-6 rounded-2xl border border-accent/20 bg-accent-soft px-6 py-4 text-center font-sans text-sm font-semibold leading-relaxed text-ink" data-id="element-246" data-mp="2di6ack2sraiq">
          Totale: 70+ lezioni complete · tutto strutturato, testato e pronto
        </p>
      </div>
    </section>;
}